import '../node_modules/core-js/modules/es.array.reverse.js';
import '../node_modules/core-js/modules/es.regexp.exec.js';
import '../node_modules/core-js/modules/es.string.replace.js';

/**
 * This function applies a given mask to value, where 0 can be any digit.
 * @param mask
 * @param value
 */
function applyPhoneMask(mask, value) {
  if (!value) {
    return undefined;
  }
  const digits = value.replace(/\D/g, '').split('').reverse();
  if (digits.length === 0) {
    return undefined;
  }
  let index = mask.length;
  const result = mask.replace(/0/g, (match, offset) => {
    const lastDigit = digits.pop();
    if (digits.length === 0 && lastDigit !== undefined) {
      index = offset;
    }
    return lastDigit || '';
  });
  return result.slice(0, index + 1) + digits.reverse().join('');
}

export { applyPhoneMask };
